import { Component, OnInit, Input, Output, EventEmitter, ViewChild, TemplateRef } from '@angular/core';
import { ApiService } from 'src/app/common/services/api.service';
import { TranslateService } from '@ngx-translate/core';
import * as _ from "lodash";
import { NgSelectComponent } from '@ng-select/ng-select';
import { TemplateService } from '../../template/template.service';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ClientService } from '../../client/client.service';
import * as moment from 'moment';

@Component({
    selector: 'app-processcontrol',
    templateUrl: './processcontrol.component.html',
    styleUrls: ['./processcontrol.component.scss']
})
export class ProcesscontrolComponent implements OnInit {
    @Output() controlValueChange = new EventEmitter();
    @Input() wizard: any;
    @Input() control: any;
    @Input() referentials: any;
    @ViewChild('ngSelect', null) ngSelect: NgSelectComponent;
    @Input() userAction: any;

    moment: any = moment;
    items: any = [];
    loadingDDLdata: boolean = false;

    searchResult: any = [];
    selectedResult: any;
    criteria: any = {};
    isDisabled: any = false;
    isReadOnly: boolean = false;
    noData: boolean = false;
    isFastCreate: boolean = true;

    @ViewChild('newLead', null) endorsementModal: TemplateRef<any>;
    clientWizard: any = null;
    newLeadProcessCode: string = "";
    newClientProcessCode: string = "";

    constructor(private apiService: ApiService,
        public translate: TranslateService,
        private templateService: TemplateService,
        private toastrService: ToastrService,
        private modalService: NgbModal,
        private clientService: ClientService
    ) {

    }

    ngOnInit() {
        this.noData = true;
        if (this.control.FieldType == "DateTime" && this.control.Value) {
            var dateParts = [];
            dateParts = this.control.Value.split('/');
            if (dateParts.length > 1) {
                this.control.DateValue = this.getDateValue({ "day": parseInt(dateParts[0]), "month": parseInt(dateParts[1]), "year": parseInt(dateParts[2].substring(0, 4)) });
            } else {
                dateParts = this.control.Value.split('-');
                this.control.DateValue = this.getDateValue({ "day": parseInt(dateParts[2].substring(0, 4)), "month": parseInt(dateParts[1]), "year": parseInt(dateParts[0]) });
            }

            if (this.control.Properties['MinimumDate'].Value) {
                dateParts = this.control.Properties['MinimumDate'].Value.split('-');
                this.control.minDate = { "day": parseInt(dateParts[2].substring(0, 4)), "month": parseInt(dateParts[1]), "year": parseInt(dateParts[0]) };
            }

            if (this.control.Properties['MaximumDate'].Value) {
                dateParts = this.control.Properties['MaximumDate'].Value.split('-');
                this.control.maxDate = { "day": parseInt(dateParts[2].substring(0, 4)), "month": parseInt(dateParts[1]), "year": parseInt(dateParts[0]) };
            }
        }

        if ((this.control.FieldType == "chkUser" || this.control.FieldType == "YesNo") && this.control.Value) {
            if (this.control.Value == 'Y' || this.control.Value == true || this.control.Value.toString().toLowerCase()=="true")
                this.control.Value = true;
            else
                this.control.Value = false;
        }

        if (this.control.Referential && this.control.Referential != "0") {
            this.control.Items = this.filterDropDownData(this.control);
            this.getDependencyReferentials();
        }

        if (this.control.Properties['PolicyReadOnly'].Value == true || this.control.Properties['OfferReadOnly'].Value == true) {
            this.isReadOnly = true;
        }
        var controltest = this.control;
        this.templateService.executeScript(this.wizard.Referentials, this.wizard, this.control, 'OnLoad', this.wizard.Variables, null, null, null);

        //execute product generator script only if ExecuteScriptOnPageLoad is true
        if (this.control.Properties['ExecuteScriptOnPageLoad'] && this.control.Properties['ExecuteScriptOnPageLoad'].Value == true)
            this.executeProductScipt();
    }

    filterDropDownData(control) {
        var selectedItems = [];
        this.loadingDDLdata = true;
        if (control.Referential &&
            control.Properties['FilterData'] &&
            control.Properties['FilterData'].Values &&
            control.Properties['FilterData'].Values.length > 0 &&
            this.referentials[control.Referential] &&
            this.referentials[control.Referential].Values) {
            for (var i = 0; i < control.Properties['FilterData'].Values.length; i++) {
                var key = control.Properties['FilterData'].Values[i];
                selectedItems.push({ "Key": key, "Value": this.referentials[control.Referential].Values[key] });
            }
        }
        else if (control.Referential &&
            this.referentials[control.Referential] &&
            this.referentials[control.Referential].Values) {
            for (var refKey in this.referentials[control.Referential].Values)
                selectedItems.push({ "Key": refKey, "Value": this.referentials[control.Referential].Values[refKey] });
        }
        else
            selectedItems = [];
        if (control.Value && !selectedItems.find(item => item.Key == control.Value))
            control.Value = "";
        this.loadingDDLdata = false;
        return selectedItems;
    }

    valueChange(changedValue, event) {

        if (this.control.FieldType == "DateTime" &&
            changedValue &&
            changedValue.day &&
            changedValue.month &&
            changedValue.year) {
            //transfer from temp variable to actual model
            this.control.Value = `0${changedValue.day}`.slice(-2) + "/" + `0${changedValue.month}`.slice(-2) + "/" + changedValue.year;
        }
        else if (this.control.FieldType == "DateTime" &&
            event == "blur" &&
            changedValue) {
            //user input is invalid date so clear it off
            this.control.DateValue = null;
            this.control.Value = "";
        }
        else if (this.control.FieldType == "DateTime" && changedValue) {
            //user input in progress, not a complete date
            this.control.Value = this.moment(changedValue).format("DD/MM/YYYY");
        }
        else if (this.control.FieldType == "DateTime") {
            //user input in progress, not a complete date
            if (!changedValue && !this.control.DateValue && this.control.Value) {
                this.control.Value = this.control.DateValue;
            }
            return;
        }

        //get end date based on stard date and number of days
        if (this.wizard.SystemIndicator != "L" &&
            this.control.Properties['SystemName'] &&
            this.control.Properties['SystemName'].Value == "SystemPolicy.NumberOfDays") {



            var controlGroup = {
                Controls: {}
            };

            var foundNoOfDays = false, foundStartDate = false;
            for (var stepKey in this.wizard.Steps) {

                for (var groupKey in this.wizard.Steps[stepKey].ControlGroups) {
                    for (var controlKey in this.wizard.Steps[stepKey].ControlGroups[groupKey].Controls) {
                        if (this.wizard.Steps[stepKey].ControlGroups[groupKey].Controls[controlKey].Properties['SystemName'] &&
                            this.wizard.Steps[stepKey].ControlGroups[groupKey].Controls[controlKey].Properties['SystemName'].Value == "SystemPolicy.StartDate") {
                            foundNoOfDays = true;
                            controlGroup.Controls["SystemPolicy.StartDate"] =
                                this.wizard.Steps[stepKey].ControlGroups[groupKey].Controls[controlKey];
                            break;
                        }
                    }
                    if (foundNoOfDays) break;
                }
  
                //sections
                var sections = this.wizard.Steps[stepKey].Sections;
                for (var sectionKey in sections) {
                    for (var groupKey in sections[sectionKey].ControlGroups) {
                        for (var controlKey in sections[sectionKey].ControlGroups[groupKey].Controls) {
                            if (sections[sectionKey].ControlGroups[groupKey].Controls[controlKey].Properties['SystemName'] &&
                                sections[sectionKey].ControlGroups[groupKey].Controls[controlKey].Properties['SystemName'].Value == "SystemPolicy.NumberOfDays") {
                                foundStartDate = true;
                                controlGroup.Controls["SystemPolicy.NumberOfDays"] =
                                    sections[sectionKey].ControlGroups[groupKey].Controls[controlKey];
                                break;
                            }
                        }
                        if (foundStartDate) break;
                    }
                    if (foundStartDate) break;
                }
            }

            if (foundNoOfDays && foundStartDate) {
                this.apiService.post("Api/QuoteApi/GetEndDateUsingDays/", controlGroup).subscribe((result: any) => {
                    if (result.EndDate) {
                        var control = this.getControl("SystemPolicy.EndDate");
                        control.TimeValue = result.EndTime;
                        control.Value = result.EndDate;
                        var dateParts = result.EndDate.split('/');
                        if (dateParts.length > 1) {
                            control.DateValue = this.getDateValue({
                                "day": parseInt(dateParts[0]),
                                "month": parseInt(dateParts[1]), "year": parseInt(dateParts[2].substring(0, 4))
                            });
                        }
                    }
                });
            }
        }

        if (this.wizard.SystemIndicator != "L" &&
            this.control.Properties['SystemName'] &&
            this.control.Properties['SystemName'].Value == "SystemPolicy.StartDate") {
            this.apiService.post("Api/QuoteApi/GetEndDate/", this.control).subscribe((result: any) => {
                if (result.EndDate) {
                    var control = this.getControl("SystemPolicy.EndDate");
                    control.TimeValue = result.EndTime;
                    control.Value = result.EndDate;
                    var dateParts = result.EndDate.split('/');
                    if (dateParts.length > 1) {
                        control.DateValue = this.getDateValue({ "day": parseInt(dateParts[0]), "month": parseInt(dateParts[1]), "year": parseInt(dateParts[2].substring(0, 4)) });
                    }
                }
            });
        }

        if (this.control.FieldType == "Number" &&
            this.control.Properties['EnableSearch'] &&
            this.control.Properties['EnableSearch'].Value == true) {
            if (!this.control.Value)
                this.control.ValueName = null;
        }

        this.templateService.executeScript(this.wizard.Referentials, this.wizard, this.control, null, this.wizard.Variables, null, null, null);

        this.getDependencyReferentials();

        //execute product generator script
        this.executeProductScipt();

        
        //CHANGES BY ZAHRAA - recalculate the premium values
        if (this.control.OfferCode) {
            var wizard = this.wizard;

            var isSync = false;

            if (this.control.Properties &&
                this.control.Properties["SyncValue"] &&
                this.control.Properties["SyncValue"].Value)
                isSync = this.control.Properties["SyncValue"].Value;

            //Loop to get the step code
            var stepOfferCode = '';
            for (var step in this.wizard.Steps) {
                if (this.wizard.Steps[step].Type == 'Offer')
                    stepOfferCode = this.wizard.Steps[step].Code;
            }

            //UAT issue fix: on entering the cover this.control values, automatically include the cover
            if (this.control.Value && this.control.CoverCode) {
                var sectioncd = this.control.SectionCode;
                var covercd = this.control.CoverCode;
                
                if (wizard.Steps[stepOfferCode].Offers[this.control.OfferCode].Sections[sectioncd].Covers[covercd].Selected == false) {
                    var tempCover = wizard.Steps[stepOfferCode].Offers[this.control.OfferCode].Sections[sectioncd].Covers[covercd];
                    tempCover.Selected = true;
                    //cover selection changed so execute if there is any client script
                    if (tempCover.Scripts && tempCover.Scripts['OnChange'] && tempCover.Scripts['OnChange'].IsChange)
                        this.templateService.executeScript(this.wizard.Referentials, this.wizard, this.control, null, this.wizard.Variables, tempCover.Scripts, tempCover, this.control.OfferCode);
                }
            }

            if (!isSync)
                this.controlValueChange.emit(this.control.OfferCode);
            else {
                for (var offerKey in this.wizard.Steps[stepOfferCode].Offers) {
                    if (offerKey === this.control.OfferCode) continue;

                    if (!this.control.SectionCode && !this.control.CoverCode) {
                        var controls = this.wizard.Steps[stepOfferCode].Offers[offerKey].Controls;
                        for (var controlKey in controls) {
                            if (controlKey === this.control.Code) {
                                controls[controlKey].Value = this.control.Value;
                                break;
                            }
                        }
                    }

                    if (this.control.SectionCode && !this.control.CoverCode) {
                        var sections = this.wizard.Steps[stepOfferCode].Offers[offerKey].Sections;
                        for (var sectionKey in sections) {
                            if (sectionKey !== this.control.SectionCode) continue;
                            var controls = sections[sectionKey].Controls;
                            for (var controlKey in controls) {
                                if (controlKey === this.control.Code) {
                                    controls[controlKey].Value = this.control.Value;
                                    break;
                                }
                            }
                        }
                    }

                    if (this.control.SectionCode && this.control.CoverCode) {
                        var sections = this.wizard.Steps[stepOfferCode].Offers[offerKey].Sections;
                        for (var sectionKey in sections) {
                            if (sectionKey !== this.control.SectionCode) continue;
                            var covers = sections[sectionKey].Covers;
                            for (var coverKey in covers) {
                                if (coverKey !== this.control.CoverCode) continue;
                                var controls = covers[coverKey].Controls;
                                for (var controlKey in controls) {
                                    if (controlKey === this.control.Code) {
                                        controls[controlKey].Value = this.control.Value;
                                        break;
                                    }
                                }
                            }
                        }
                    }
                }

                for (var offerKey in this.wizard.Steps[stepOfferCode].Offers)
                    this.controlValueChange.emit(offerKey);
            }
        }

        //END of ZAHRAA CHANGES

    }


    getDependencyReferentials() {
        if (this.control.FieldType == "Lookup" &&
            this.referentials[this.control.Referential] &&
            this.referentials[this.control.Referential].IsDependency) {

            var controls = {};
            for (var stepKey in this.wizard.Steps) {
                for (var controlKey in this.wizard.Steps[stepKey].Controls) {
                    controls[controlKey] = this.wizard.Steps[stepKey].Controls[controlKey];
                }

                for (var groupKey in this.wizard.Steps[stepKey].ControlGroups) {
                    for (var controlKey in this.wizard.Steps[stepKey].ControlGroups[groupKey].Controls) {
                        controls[controlKey] = this.wizard.Steps[stepKey].ControlGroups[groupKey].Controls[controlKey];
                    }
                }
            }

            var dependency = { "Code": this.control.Referential, "Value": this.control.Value, Module: "CLIENT" };

            this.apiService.post("Api/TemplateApi/DependencyRef/", dependency).subscribe((res: any) => {
                var dependencies = [];
                for (var refrentialKey in res) {
                    if (this.referentials[refrentialKey]) {
                        this.referentials[refrentialKey].Values = _.cloneDeep(res[refrentialKey].Values);
                        dependencies.push(refrentialKey);
                    }
                }

                //although its not efficient but it seems we have to rebind the dropdown
                for (var stepKey in this.wizard.Steps) {
                    for (var controlKey in this.wizard.Steps[stepKey].Controls) {
                        if (this.wizard.Steps[stepKey].Controls[controlKey].Referential &&
                            dependencies.indexOf(this.wizard.Steps[stepKey].Controls[controlKey].Referential) >= 0) {
                            this.wizard.Steps[stepKey].Controls[controlKey].Items =
                                this.filterDropDownData(this.wizard.Steps[stepKey].Controls[controlKey]);
                        }
                    }

                    for (var groupKey in this.wizard.Steps[stepKey].ControlGroups) {
                        for (var controlKey in this.wizard.Steps[stepKey].ControlGroups[groupKey].Controls) {
                            if (this.wizard.Steps[stepKey].ControlGroups[groupKey].Controls[controlKey].Referential &&
                                dependencies.indexOf(this.wizard.Steps[stepKey].ControlGroups[groupKey].Controls[controlKey].Referential) >= 0) {
                                this.wizard.Steps[stepKey].ControlGroups[groupKey].Controls[controlKey].Items =
                                    this.filterDropDownData(this.wizard.Steps[stepKey].ControlGroups[groupKey].Controls[controlKey]);
                            }
                        }
                    }
                }

            });
        }
    }

    executeProductScipt()
    {
        if (!this.wizard.IsView &&
                (this.control.Properties && (
                    (this.wizard.IsPolicy && this.control.Properties['PolicyReadOnly'] && !this.control.Properties['PolicyReadOnly'].Value) ||
                    (!this.wizard.IsPolicy && this.control.Properties['OfferReadOnly'] && !this.control.Properties['OfferReadOnly'].Value)))
            && this.control.SectionCode
            && !this.control.CoverCode
            && this.control.ScriptCode
            && this.control.Properties["DisbaleProductScript"].Value === false)
        {
            //get standard control values from all step
            var standardControls = {};
            for (var stepCode in this.wizard.Steps) {
                for (var controlKey in this.wizard.Steps[stepCode].Controls) {
                    if (this.wizard.Steps[stepCode].Controls[controlKey].Value && this.wizard.Steps[stepCode].Controls[controlKey].Value.Code)
                        standardControls[controlKey] =
                            {
                                "Value": this.wizard.Steps[stepCode].Controls[controlKey].Value.Code,
                                "Properties": this.wizard.Steps[stepCode].Controls[controlKey].Properties,
                                "FieldType": this.wizard.Steps[stepCode].Controls[controlKey].FieldType,
                                "KeyValue": this.wizard.Steps[stepCode].Controls[controlKey].KeyValue
                            };
                    else
                        standardControls[controlKey] =
                            {
                                "Value": this.wizard.Steps[stepCode].Controls[controlKey].Value,
                                "Properties": this.wizard.Steps[stepCode].Controls[controlKey].Properties,
                                "FieldType": this.wizard.Steps[stepCode].Controls[controlKey].FieldType,
                                "KeyValue": this.wizard.Steps[stepCode].Controls[controlKey].KeyValue
                            };
                }
                for (var groupCode in this.wizard.Steps[stepCode].ControlGroups) {
                    for (var controlKey in this.wizard.Steps[stepCode].ControlGroups[groupCode].Controls) {
                        standardControls[controlKey] =
                            {
                                "Value": this.wizard.Steps[stepCode].ControlGroups[groupCode].Controls[controlKey].Value,
                                "Properties": this.wizard.Steps[stepCode].ControlGroups[groupCode].Controls[controlKey].Properties,
                                "FieldType": this.wizard.Steps[stepCode].ControlGroups[groupCode].Controls[controlKey].FieldType,
                                "KeyValue": this.wizard.Steps[stepCode].ControlGroups[groupCode].Controls[controlKey].KeyValue
                            };
                    }
                }
            }

            var stepKey;
            for (var stepcode in this.wizard.Steps) {
                for (var sectionCode in this.wizard.Steps[stepcode].Sections) {
                    for (var groupCode in this.wizard.Steps[stepcode].Sections[sectionCode].ControlGroups) {
                        for (var controlCode in this.wizard.Steps[stepcode].Sections[sectionCode].ControlGroups[groupCode].Controls) {
                            if (sectionCode == this.control.SectionCode && controlCode == this.control.Code)
                                stepKey = stepcode;
                        }
                    }
                }
            }

            var section = this.wizard.Steps[stepKey].Sections[this.control.SectionCode];

            var model = {
                "ProductCode": this.wizard.ProductCode,
                "ProcessCode": this.wizard.ProcessCode,
                "DepartmentCode": this.wizard.DepartmentCode,
                "SystemIndicator": this.wizard.SystemIndicator,
                "Section": section,
                "Control": this.control,
                "Controls": standardControls,
                "Referentials": this.referentials,
                "Variables": this.wizard.Variables,
                "ClientKey": this.wizard.ClientKey,
                "IsOffer": this.wizard.PolicyKey ? "N" : "Y"
            };

            this.apiService.post('Api/PolicyTemplateApi/ItemControlScript/', model).subscribe((result: any) => {
                this.wizard.Variables = result.Variables;
                this.wizard.Referentials = this.referentials = result.Referentials;

                for (var stepKey in this.wizard.Steps) {
                    var step = this.wizard.Steps[stepKey];
                    for (var sectionKey in step.Sections) {
                        if (sectionKey == result.Section.Code) {
                            for (var controlKey in step.Sections[sectionKey].Controls) {
                                var control = step.Sections[sectionKey].Controls[controlKey];

                                if (result.Control.Code == controlKey) {
                                    var isError = result.Errors && result.Errors.length > 0 ? true : false;
                                    if (isError && result.Errors[0].Severity != 1) {
                                        control.productError = isError;
                                        this.toastrService.error(result.Errors[0].Message, result.Control.Text);
                                    }
                                    else if (isError) {
                                        control.productError = false;
                                        this.toastrService.error(result.Errors[0].Message, result.Control.Text);
                                    }
                                    else {
                                        control.productError = false;
                                    }
                                }

                                var refKey = sectionKey + "_" + controlKey;
                                if (result.Referentials[refKey]) {
                                    this.wizard.Referentials[refKey] = { "Values": _.cloneDeep(result.Referentials[refKey].Values), "Code": refKey };
                                    control.Referential = refKey;

                                    if (result.Section.Controls[controlKey].Value &&
                                        result.Referentials[refKey].Values[result.Section.Controls[controlKey].Value] &&
                                        (result.Section.Controls[controlKey].Value == "0" &&
                                            result.Referentials[refKey].Values[result.Section.Controls[controlKey].Value].trim() == "") == false) {
                                        control.OldValue = control.Value = result.Section.Controls[controlKey].Value;

                                        if (result.Section.Controls[controlKey].FieldType == "DateTime") {
                                            var dateParts = [];
                                            dateParts = result.Section.Controls[controlKey].Value.split('/');
                                            if (dateParts.length > 1) {
                                                control.DateValue = this.getDateValue({ "day": parseInt(dateParts[0]), "month": parseInt(dateParts[1]), "year": parseInt(dateParts[2].substring(0, 4)) });
                                            }
                                        }
                                    }
                                    else
                                        control.DateValue = control.OldValue = control.Value = null;

                                    control.Items = this.filterDropDownData(control); //to referesh the dropdown data
                                }
                                else if (result.Section.Controls[controlKey]) //overwrite values from product gen
                                {
                                    control.OldValue = control.Value = result.Section.Controls[controlKey].Value;

                                    if (control.FieldType == "DateTime") {
                                        var dateParts = [];
                                        dateParts = result.Section.Controls[controlKey].Value.split('/');
                                        if (dateParts.length > 1) {
                                            control.DateValue = this.getDateValue({ "day": parseInt(dateParts[0]), "month": parseInt(dateParts[1]), "year": parseInt(dateParts[2].substring(0, 4)) });
                                        }
                                    }
                                }
                            }

                            for (var groupCode in this.wizard.Steps[stepKey].Sections[sectionKey].ControlGroups) {
                                for (var controlKey in this.wizard.Steps[stepKey].Sections[sectionKey].ControlGroups[groupCode].Controls) {
                                    var control = this.wizard.Steps[stepKey].Sections[sectionKey].ControlGroups[groupCode].Controls[controlKey];

                                    if (result.Control.Code == controlKey) {
                                        var isError = result.Errors && result.Errors.length > 0 ? true : false;
                                        if (isError && result.Errors[0].Severity != 1) {
                                            control.productError = isError;
                                            this.toastrService.error(result.Errors[0].Message, result.Control.Text);
                                        }
                                        else if (isError) {
                                            control.productError = false;
                                            this.toastrService.error(result.Errors[0].Message, result.Control.Text);
                                        }
                                        else {
                                            control.productError = false;
                                        }
                                    }

                                    var refKey = sectionKey + "_" + controlKey;
                                    if (result.Referentials[refKey]) {
                                        this.wizard.Referentials[refKey] = { "Values": _.cloneDeep(result.Referentials[refKey].Values), "Code": refKey };
                                        control.Referential = refKey;

                                        if (result.Section.ControlGroups[groupCode].Controls[controlKey].Value &&
                                            result.Referentials[refKey].Values[result.Section.ControlGroups[groupCode].Controls[controlKey].Value] &&
                                            (result.Section.ControlGroups[groupCode].Controls[controlKey].Value == "0" &&
                                                result.Referentials[refKey].Values[result.Section.ControlGroups[groupCode].Controls[controlKey].Value].trim() == "") == false) {
                                            control.OldValue = control.Value = result.Section.ControlGroups[groupCode].Controls[controlKey].Value;

                                            if (control.FieldType == "DateTime") {
                                                var dateParts = [];
                                                dateParts = result.Section.ControlGroups[groupCode].Controls[controlKey].Value.split('/');
                                                if (dateParts.length > 1) {
                                                    control.DateValue = this.getDateValue({ "day": parseInt(dateParts[0]), "month": parseInt(dateParts[1]), "year": parseInt(dateParts[2].substring(0, 4)) });
                                                }
                                            }
                                        }
                                        else
                                            control.DateValue = control.OldValue = control.Value = null;

                                        control.Items = this.filterDropDownData(control); //to referesh the dropdown data
                                    }
                                    else if (result.Section.ControlGroups[groupCode].Controls[controlKey]) //overwrite values from product gen
                                    {
                                        control.OldValue = control.Value = result.Section.ControlGroups[groupCode].Controls[controlKey].Value;
                                        if (control.Items) control.Items = [];

                                        if (control.FieldType == "DateTime") {
                                            var dateParts = [];
                                            dateParts = result.Section.ControlGroups[groupCode].Controls[controlKey].Value.split('/');
                                            if (dateParts.length > 1) {
                                                control.DateValue = this.getDateValue({ "day": parseInt(dateParts[0]), "month": parseInt(dateParts[1]), "year": parseInt(dateParts[2].substring(0, 4)) });
                                            }
                                        }
                                    }
                                }
                            }

                            break;
                        }
                    }
                }

                if (this.wizard.Scripts) {
                    for (var scriptKey in this.wizard.Scripts) {
                        if (this.wizard.Scripts[scriptKey].IsCalculationComplete) {
                            this.templateService.executeGlobalScript(this.wizard.Referentials,
                                this.wizard.Steps, null, result.Variables, false, this.wizard.Scripts[scriptKey].Value);
                        }
                    }
                }
            },
            (response) => {
                if (this.wizard.Scripts) {
                    for (var scriptKey in this.wizard.Scripts) {
                        if (this.wizard.Scripts[scriptKey].IsCalculationError) {
                            this.templateService.executeGlobalScript(this.wizard.Referentials,
                                this.wizard.Steps, null, response.data.Variables, true, this.wizard.Scripts[scriptKey].Value);
                        }
                    }
                }
            });
        }
    }

    onResize(event) {
        if (this.ngSelect && this.ngSelect.isOpen) this.ngSelect.close();
    }

    openSearchModal(type, content) {
        this.noData = false;
        this.modalService.open(content, { centered: true, size: 'lg' }).result.then((result) => {
            if (result == 'Select') {
                //write selected client name and key in the field
                if (type == 'client') {
                    this.control.Value = this.selectedResult.ClientKey;
                    this.control.ValueName = this.selectedResult.ClientName;
                }
                else if (type == 'address')
                    this.control.Value = this.searchResult.AddressKey;
                else if (type == 'arrangement') {
                    this.control.Value = this.selectedResult.ArrangementCode;
                    this.control.KeyValue = this.selectedResult.ArrangementCode;
                    this.controlValueChange.emit(this.control.Code);
                }
                this.clearSearch();
                this.searchResult = [];
            }
            else {
                this.clearSearch();
                this.searchResult = [];
            }
        }, (reason) => {
            this.clearSearch();
            this.searchResult = [];
        });
    }

    clearSearch() {
        this.criteria = {};
        this.searchResult = [];
    }

    clientSearch() {
        this.noData = false;
        var model = {
            PageNo: this.criteria.PageNo ? this.criteria.PageNo : 1,
            PageSize: this.criteria.PageSize ? this.criteria.PageSize : 10,
            ClientKey: this.criteria.clientKey ? this.criteria.clientKey : "" ,
            ClientName: this.criteria.Name,
            IDRegNumber: this.criteria.idRegNumber,
            WorkTelephone: this.criteria.telephoneNumber,
            IsCompany: "",
            BirthDate: this.criteria.DateOfBirth
        };

        //model.IsCompany = 'N';
        this.apiService.post("Api/ClientApi/Search/", model).subscribe((result: any) => {
            this.searchResult = result.rows;
            this.criteria.PageNo = result.page;
            this.criteria.TotalRecords = result.records;
            if (result.records == 0) this.noData = true;
        });
    }

    arrangeSearch() {
        var model = {
            PageNo: this.criteria.PageNo ? this.criteria.PageNo : 1,
            PageSize: this.criteria.PageSize ? this.criteria.PageSize : 10,
            AgentName: this.criteria.AgentName,
            ArrangementCode: this.criteria.ArrangementCode,
            AgentCode: this.criteria.AgentCode,
            Status: "Active",
            PlanKey: this.wizard.ProductCode ? this.wizard.ProductCode : 0
        };
        
        this.apiService.post("Api/ArrangementApi/Search/", model).subscribe((result: any) => {
            this.searchResult = result.rows;
            this.criteria.PageNo = result.page;
            this.criteria.TotalRecords = result.records;
        });
    }

    selectRow(row) {
        this.selectedResult = row;
    }

    
    getTemplate() {
        var model = { ClientKey: "" };
        this.apiService.post("Api/ClientTemplateApi/SearchClientProcesses/", model).subscribe((res) => {
            this.newLeadProcessCode = res["CLIENT_NEWLEAD"];
            this.newClientProcessCode = res["CLIENT_NEWCLIENT"];

            this.loadTemplate();
        });
    }
        
    loadTemplate()
    {        
        var model = {
            "ProductCode": "",
            "ProcessCode": this.newLeadProcessCode, //DMISR => 433 , TLTI => 395
            "DepartmentCode": ""
        };

        this.apiService.post("Api/ClientTemplateAPI/Load/", model).subscribe((res: any) => {

            for (var stepCode in res.Steps) {
                for (var groupCode in res.Steps[stepCode].ControlGroups) {
                    for (var controlCode in res.Steps[stepCode].ControlGroups[groupCode].Controls) {
                        if (res.Steps[stepCode].ControlGroups[groupCode].Controls[controlCode].Properties['OnLoad'].Value) {
                            this.templateService.executeScript(res.Referentials, res.Steps, res.Steps[stepCode].ControlGroups[groupCode].Controls[controlCode], "OnLoad", res.Variables, null, null, null);
                        }
                    }
                }
            }

            this.clientService.wizard = res;
            this.clientWizard = this.clientService.wizard;

            this.modalService.dismissAll();
            this.modalService.open(this.endorsementModal);
        });        
    }

    AddLead() {
        // Verify that all required fields are not blank.
        var requiredControlLength = this.clientService.validateControls(this.clientWizard);

        if (requiredControlLength > 0) {
            this.toastrService.error(this.translate.instant("Provide details for all required fields"));
        }
        else {
            this.apiService.post("Api/ClientAPI/AddLead/", this.clientWizard).subscribe((res: any) => {
                if (res.ErrorKey == 0) {
                    this.toastrService.success(this.translate.instant("Client created successfully"));
                    this.control.Value = res.Client.ClientKey;
                    this.control.ValueName = res.Client.First + " " + res.Client.SurName;
                    this.modalService.dismissAll();
                }
                else if (res.ErrorKey == 1) {
                    this.toastrService.warning(this.translate.instant("integrity failed.."));
                    //this.integrityCheck = res.Integrity;
                    //this.isCritical = "No";
                    //for (var integrityKey in this.integrityCheck) {
                    //    if (this.integrityCheck[integrityKey].CheckSeverity == 3)
                    //        this.isCritical = "Yes";
                    //}
                    //this.modalService.open(this.rulesValidationResult, { centered: true, size: 'lg' });
                }
                else if (res.ErrorKey == 2) {
                    this.toastrService.error(this.translate.instant("Unique constraint violation. Please try again."));
                } else if (res.ErrorKey == 3) {
                    this.toastrService.error(this.translate.instant("Failed to create client"));
                }
            });
        }
    }

    getControl(systemName) {
        var referential = {};
        for (var stepKey in this.wizard.Steps) {

            var controls = this.wizard.Steps[stepKey].Controls;
            for (var controlKey in controls) {
                if (controls[controlKey].Properties["SystemName"].Value == systemName) {
                    return controls[controlKey];
                }
            }

            for (var groupKey in this.wizard.Steps[stepKey].ControlGroups) {
                var controls = this.wizard.Steps[stepKey].ControlGroups[groupKey].Controls;
                for (var controlKey in controls) {
                    if (controls[controlKey].Properties["SystemName"].Value == systemName) {
                        return controls[controlKey];
                    }
                }
            }

            for (var transKey in this.wizard.Steps[stepKey].ClaimTransacReferences) {
                for (var groupKey in this.wizard.Steps[stepKey].ClaimTransacReferences[transKey].ControlGroups) {
                    var controls = this.wizard.Steps[stepKey].ClaimTransacReferences[transKey].ControlGroups[groupKey].Controls;
                    for (var controlKey in controls) {
                        if (controls[controlKey].Properties["SystemName"].Value == systemName) {
                            return controls[controlKey];
                        }
                    }
                }

            }
        }
        return null;
    }

    getDateValue(dateVal) {
        var date = new Date(dateVal.year, dateVal.month - 1, dateVal.day);

        return date;
    }
}
